import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Professional Coder.", "Frontend developer.", "UI Designer."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hey, I'm <span className="text-designColor capitalize">Bhairav</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          As a skilled React JS and frontend developer, I have hands on experience of devloping  dynamic, responsive web interfaces using component-based architecture. My expertise in HTML, CSS, and JavaScript ensures high-performance applications with seamless user experiences. Explore my portfolio to see innovative projects that blend visual appeal with functionality.

        </p>
      </div>
      {/* Media */}
      <Media />
    </div>
  );
}

export default LeftBanner